import React from 'react';

// eslint-disable-next-line react/display-name
export default () => (
    <svg
        width="25"
        height="26"
        viewBox="0 0 25 26"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M3.72852 5.7818C3.72852 5.32184 4.06417 4.94897 4.47823 4.94897H8.23206C8.64612 4.94897 8.98178 5.32184 8.98178 5.7818V6.7867C8.82931 6.76021 8.69612 6.653 8.53639 6.653C6.72366 6.19961 5.31643 8.11107 5.2843 9.17993C5.25217 10.2488 5.39581 10.2986 5.39581 10.3915H4.47823C4.06417 10.3915 3.72852 10.0186 3.72852 9.55864V5.7818Z"
            fill="#7A7D85"
        />
        <path
            d="M10.8821 9.99761C10.8821 11.2054 9.90213 12.1845 8.69325 12.1845C7.48438 12.1845 6.50439 11.2054 6.50439 9.99761C6.50439 8.78979 7.48438 7.81067 8.69325 7.81067C9.90213 7.81067 10.8821 8.78979 10.8821 9.99761Z"
            fill="#7A7D85"
        />
        <path
            d="M0 2.17462C0 1.24975 0.815429 0.5 1.82131 0.5H12.1954V2.25436H1.90804V14.1795H8.67093V15.9339H1.82131C0.815432 15.9339 0 15.1842 0 14.2593V2.17462Z"
            fill="#7A7D85"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M10.9339 23.5076H22.9411C22.4641 21.051 20.2496 19.1869 17.5843 19.1869H16.2908C13.6254 19.1869 11.4109 21.051 10.9339 23.5076ZM23.0378 23.5075C23.0378 23.5075 23.0376 23.5075 23.0372 23.5075L23.0378 23.5075ZM8.89993 23.3553C9.46525 19.86 12.5614 17.1945 16.2908 17.1945H17.5843C21.3136 17.1945 24.4098 19.86 24.9751 23.3553C25.1781 24.6107 24.1057 25.5 23.0365 25.5H10.8385C9.76933 25.5 8.69689 24.6107 8.89993 23.3553Z"
            fill="#7A7D85"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M16.8613 11.2218C15.2284 11.2218 13.8748 12.5482 13.8748 14.2206C13.8748 15.8931 15.2284 17.2194 16.8613 17.2194C18.4942 17.2194 19.8478 15.8931 19.8478 14.2206C19.8478 12.5482 18.4942 11.2218 16.8613 11.2218ZM11.8442 14.2206C11.8442 11.4803 14.074 9.22937 16.8613 9.22937C19.6486 9.22937 21.8784 11.4803 21.8784 14.2206C21.8784 16.9609 19.6486 19.2119 16.8613 19.2119C14.074 19.2119 11.8442 16.9609 11.8442 14.2206Z"
            fill="#7A7D85"
        />
    </svg>
);
